import { useEffect, useState } from "react";
import { fetchLearnerDashboardData } from "PlatForms/OrgLMS/Services/LearnerService/LearnerService";
import api from "Common/Client/Interceptor";

const useLearnerDashboard = () => {
  const [dashboardData, setDashboardData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const token = localStorage.getItem("token");
        // Parent returns summary/stats only; the trainings and upcoming
        // deadlines lists were moved to separate paginated endpoints.
        const [data, trainingsRes, deadlinesRes] = await Promise.all([
          fetchLearnerDashboardData(token),
          api.get("/Training/Learner/List", {
            params: { completed: false, pageNumber: 1, pageSize: 10 },
          }),
          api.get("/Training/Learner/UpcomingDeadlines/List", {
            params: { pageNumber: 1, pageSize: 10 },
          }),
        ]);
        setDashboardData({
          ...data,
          trainings: trainingsRes.data.items || [],
          upcomingDeadlines: deadlinesRes.data.items || [],
        });
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  return { dashboardData, loading, error };
};

export default useLearnerDashboard;
